function test_mixin() {
  window.console.log('TEST SITE SPECIFIC MIXIN')
}

export const is_tb = () => {
  return (process.env.VUE_APP_PREFIX == "tb")
}

export default {
  methods: {
    test_mixin: test_mixin,
    is_tb: is_tb
  }
}